import { getPath } from '@/router/common'

const baseUrl = {
  title: '现金录入',
  path: 'newCW'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'newCW_Index',
    component: () => import(/* webpackChunkName: "newCW_Index" */ '@/views/newCW/index/index.vue'),
    meta: {
      title: '管理费用请款'
    }
  },
  {
    path: getPath('detail', baseUrl),
    name: 'newCW_detail',
    component: () => import(/* webpackChunkName: "newCW_detail" */ '@/views/newCW/detail/index.vue'),
    meta: {
      title: '财务日记账-详情页'
    }
  },
  {
    path: getPath('Index_cc', baseUrl),
    name: 'newCW_Index_cc',
    component: () => import(/* webpackChunkName: "newCW_Index_cc" */ '@/views/newCW/index_cc/index.vue'),
    meta: {
      title: '财务日记账'
    }
  },
]
